import React, { Component } from 'react';
import { RESOLUTIONS as BREAKPOINTS } from 'services/config';
import BloxButton from 'sub_components/Common/BloxButton';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';
import LoadingCube from 'sub_components/Common/LoadingCube';
import VIP from './VIP';

const MAX_VIPS_DISPLAYED = {
	[BREAKPOINTS.LOW]: 3,
	[BREAKPOINTS.MED]: 5,
	[BREAKPOINTS.HIGH]: 5,
};

class VIPList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedType: 'private',
			showAvailableVips: true,
		};
	}

	updateSelected = selectedType => {
		this.setState({ selectedType });
	};

	mapDisplayVIPS = () => {
		const {
			share,
			shares,
			breakpoint,
			updateShare,
			editWhitelist,
			viewWhitelist,
			updateVIPsAccess,
			refreshShare,
			setModalContent,
			activeVIPs,
			availableVIPs,
			auth_status,
			site,
			company_info,
			company_info: {
				customer: { id },
			},
			ticketType,
		} = this.props;
		const { selectedType } = this.state;
		let displayVIPs = activeVIPs ? [...activeVIPs] : [];
		displayVIPs = availableVIPs && [...displayVIPs, ...availableVIPs];

		return displayVIPs.map((vip, index) => {
			if (selectedType === 'private' && vip.isPrivate) {
				return (
					<VIP
						key={`${index + 1}`}
						orgId={id}
						vip={vip}
						site={site}
						index={index}
						type='Delete'
						share={share}
						shares={shares}
						breakpoint={breakpoint}
						updateShare={updateShare}
						editWhitelist={editWhitelist}
						viewWhitelist={viewWhitelist}
						updateVIPsAccess={updateVIPsAccess}
						refreshShare={refreshShare}
						setModalContent={setModalContent}
						auth_status={auth_status}
						company_info={company_info}
						ticketType={ticketType}
					/>
				);
			} else if (selectedType === 'public' && !vip.isPrivate) {
				return (
					<VIP
						key={`${index + 1}`}
						orgId={id}
						vip={vip}
						site={site}
						index={index}
						type='Delete'
						share={share}
						shares={shares}
						breakpoint={breakpoint}
						updateShare={updateShare}
						auth_status={auth_status}
						company_info={company_info}
						editWhitelist={editWhitelist}
						viewWhitelist={viewWhitelist}
						updateVIPsAccess={updateVIPsAccess}
						refreshShare={refreshShare}
						setModalContent={setModalContent}
						ticketType={ticketType}
					/>
				);
			}
		});
	};

	checkIfEmpty = (share, activeVIPs) => {
		return !!((share && activeVIPs?.length === 0) || (share && !activeVIPs));
	};

	render() {
		const { share, breakpoint, loading, activeVIPs, availableVIPs } = this.props;
		const { selectedType } = this.state;
		let displayVIPs = activeVIPs ? [...activeVIPs] : [];
		displayVIPs = availableVIPs && [...displayVIPs, ...availableVIPs];
		const activeScroll = !!(activeVIPs && activeVIPs.length > MAX_VIPS_DISPLAYED[breakpoint]);

		const noVips = this.checkIfEmpty(share, activeVIPs);

		return (
			<>
				{!share && loading && <LoadingCube />}
				{!share && !loading && <div className='body10'>Error getting share details.</div>}
				{share && (
					<>
						{' '}
						<div className={activeScroll ? 'vips-container scroll' : 'vips-container'}>
							<div className='buttons-wrapper'>
								<BloxButton
									title='PUBLIC'
									customClass={selectedType === 'public' ? 'blox-button selected' : 'blox-button'}
									onClick={() => this.updateSelected('public')}
									id={'swift'}
									enabled
								/>
								<BloxButton
									title='PRIVATE'
									customClass={selectedType === 'private' ? 'blox-button selected' : 'blox-button'}
									onClick={() => this.updateSelected('private')}
									enabled
								/>
							</div>
							{share && activeScroll && (
								<ScrollView>
									<>{displayVIPs && this.mapDisplayVIPS()}</>
								</ScrollView>
							)}
							{share && !activeScroll && <>{displayVIPs && this.mapDisplayVIPS()}</>}
							{noVips && (
								<div className='no-active-vips'>
									<div className='text body10'>NO ACTIVE VIPS</div>
								</div>
							)}
						</div>
					</>
				)}
			</>
		);
	}
}

export default VIPList;
